import React from 'react';

import { Text as TextButton } from '../common/input/Button.jsx';

class Unsubscribe extends React.Component {
    constructor(props) {
        super(props);

        let data;
        if (props.query) {
            data = JSON.parse(props.query);
        }
        this.state = data;

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        if (event) {
            event.preventDefault();
        }
        const handler = function () {
            window.location = '/unsubscribed';
        };
        Artcloud.api.post(
            Artcloud.url.vendor.marketplace.forms.unsubscribes.post(),
            this.state,
            handler,
            handler
        );
    }

    render() {
        return (
            <div className="pop--cont pop--persona pop--active">
                <div className="pop--persona__content">
                    <form onSubmit={this.handleSubmit}>
                        <div className="header-container text--center spacer--bottom">
                            <div className="sign__main__logo" />
                            <h4 className="sign__main__header">Unsubscribe</h4>
                            <h1 className="sign__main__header--info">If you'd like to unsubscribe from our mailing list, please click the button below.</h1>
                        </div>
                        <TextButton config={{ color: 'dark' }} type="submit">UNSUBSCRIBE</TextButton>
                    </form>
                </div>
            </div>
        );
    }
}

export default Unsubscribe;